import React, { useState } from 'react'
import './census-creator.css'

interface CensusCreatorProps {
  onAddressesComplete: (addresses: string[]) => void
  initialAddress: string
}

export function CensusCreator({ onAddressesComplete, initialAddress }: CensusCreatorProps) {
  const [addresses, setAddresses] = useState<string[]>([initialAddress])
  const [currentAddress, setCurrentAddress] = useState<string>('')
  const [error, setError] = useState<string>('')

  const handleAddAddress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      if (currentAddress === '') {
        // Empty input signals completion
        onAddressesComplete(addresses)
        return
      }

      // Basic Ethereum address validation
      if (!/^0x[a-fA-F0-9]{40}$/.test(currentAddress)) {
        setError('Invalid Ethereum address format')
        return
      }

      setAddresses([...addresses, currentAddress])
      setCurrentAddress('')
      setError('')
    }
  }

  return (
    <div className="census-creator">
      <h2>Create Census</h2>
      <p>Current addresses in census:</p>
      <ul>
        {addresses.map((address, index) => (
          <li key={index}>{address}</li>
        ))}
      </ul>
      <div>
        <input
          type="text"
          value={currentAddress}
          onChange={(e) => setCurrentAddress(e.target.value)}
          onKeyPress={handleAddAddress}
          placeholder="Enter Ethereum address (press Enter) or leave empty to finish"
          className="address-input"
        />
        {error && <p className="error">{error}</p>}
      </div>
      <p className="helper-text">
        Press Enter with an empty input to complete the census
      </p>
    </div>
  )
} 